import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "checkbox-checked-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.75 7.5C3.75 5.42921 5.42921 3.75 7.5 3.75H16.504C18.5728 3.75 20.25 5.42721 20.25 7.496V16.505C20.25 18.5727 18.5729 20.25 16.504 20.25H7.496C5.42721 20.25 3.75 18.5728 3.75 16.504V7.5ZM16.504 2.25H7.5C4.60079 2.25 2.25 4.60079 2.25 7.5V16.504C2.25 19.4012 4.59879 21.75 7.496 21.75H16.504C19.4011 21.75 21.75 19.4013 21.75 16.505V7.496C21.75 4.59879 19.4012 2.25 16.504 2.25ZM16.0178 10.1323C16.3107 9.83944 16.3107 9.36457 16.0178 9.07167C15.7249 8.77878 15.25 8.77878 14.9571 9.07167L10.5964 13.4324L8.97284 11.8088C8.67994 11.5159 8.20507 11.5159 7.91217 11.8088C7.61928 12.1017 7.61928 12.5766 7.91217 12.8695L10.0661 15.0234L10.0801 15.0374C10.373 15.3303 10.8478 15.3303 11.1407 15.0374C11.1826 14.9955 11.2184 14.95 11.2483 14.9018L16.0178 10.1323Z"
    }, null, -1)
  ])))
}
export default { render: render }